module.exports = __webpack_public_path__ + "static/media/twiter.83569bc3.png";